(() => {
  const parseConfig = (root) => {
    const candidates = root.parentElement
      ? Array.from(root.parentElement.querySelectorAll('[data-sr-builder-config]'))
      : [];
    const configNode = candidates.find((node) => node.dataset.configFor === root.id);
    if (!configNode) return {};
    try {
      return JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      console.error('SR Indy Universal builder config could not be parsed.', error);
      return {};
    }
  };

  const initBuilder = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const config = parseConfig(root);
const form = root.querySelector('.sr-ring-builder__form');
const steps = Array.from(root.querySelectorAll('[data-step]'));
const timelineNodes = Array.from(root.querySelectorAll('[data-step-jump]'));
const nextButton = root.querySelector('[data-next]');
const backButton = root.querySelector('[data-back]');
const errorBox = root.querySelector('[data-error]');
const progressBar = root.querySelector('[data-progress-bar]');
const progressLabel = root.querySelector('[data-progress-label]');
const progressPercent = root.querySelector('[data-progress-percent]');
const variantIdInput = root.querySelector('[data-variant-id-input]');
const submitButton = root.querySelector('.sr-ring-builder__submit');
const submitLabel = root.querySelector('.sr-ring-builder__submit-label');
const livePrice = root.querySelector('[data-live-price]');
const finalPrice = root.querySelector('[data-final-price]');
const sizePropertyInput = root.querySelector('[data-auto-size-property]');
const sizeLabel = root.querySelector('[data-auto-size-label]');
const reviewStyle = root.querySelector('[data-review-style]');
const reviewTone = root.querySelector('[data-review-tone]');
const reviewSize = root.querySelector('[data-review-size]');
const reviewSport = root.querySelector('[data-review-sport]');
const reviewState = root.querySelector('[data-review-state]');
const reviewSportRow = root.querySelector('[data-review-sport-row]');
const reviewStateRow = root.querySelector('[data-review-state-row]');
const previewStyle = root.querySelector('[data-preview-style]');
const previewTone = root.querySelector('[data-preview-tone]');
const ringCaption = root.querySelector('[data-ring-caption]');
let ringImage = root.querySelector('.sr-ring-builder__image');
let imagePlaceholder = root.querySelector('[data-image-placeholder]');
const visualFrame = root.querySelector('.sr-ring-builder__visual-frame');
const finalVisual = root.querySelector('[data-final-visual]');
const athenaFinalVisual = root.querySelector('[data-athena-final-visual]');
const athenaSelectVisual = root.querySelector('[data-athena-select-visual]');
const athenaSelectEmblem = root.querySelector('[data-athena-select-emblem]');
const athenaSelectRing = root.querySelector('[data-athena-select-ring]');
const athenaSelectRingEmpty = root.querySelector('[data-athena-select-ring-empty]');
const apolloFinalVisual = root.querySelector('[data-apollo-final-visual]');
const apolloFrontImage = root.querySelector('[data-apollo-front-image]');
const apolloFrontEmpty = root.querySelector('[data-apollo-front-empty]');
const apolloFrontLabel = root.querySelector('[data-apollo-front-label]');
const apolloBackImage = root.querySelector('[data-apollo-back-image]');
const apolloBackEmpty = root.querySelector('[data-apollo-back-empty]');
const apolloBackLabel = root.querySelector('[data-apollo-back-label]');
const athenaSportRingImage = root.querySelector('[data-athena-sport-ring-image]');
const athenaSportRingEmpty = root.querySelector('[data-athena-sport-ring-empty]');
const athenaSportSelectionImage = root.querySelector('[data-athena-sport-selection-image]');
const athenaSportSelectionEmpty = root.querySelector('[data-athena-sport-selection-empty]');
const athenaStateRingImage = root.querySelector('[data-athena-state-ring-image]');
const athenaStateRingEmpty = root.querySelector('[data-athena-state-ring-empty]');
const athenaStateSelectionImage = root.querySelector('[data-athena-state-selection-image]');
const athenaStateSelectionEmpty = root.querySelector('[data-athena-state-selection-empty]');
const finalBezelImage = root.querySelector('[data-final-bezel-image]');
const finalBezelEmpty = root.querySelector('[data-final-bezel-empty]');
const finalBezelLabel = root.querySelector('[data-final-bezel-label]');
const finalSportImage = root.querySelector('[data-final-sport-image]');
const finalSportEmpty = root.querySelector('[data-final-sport-empty]');
const finalSportLabel = root.querySelector('[data-final-sport-label]');
const finalStateImage = root.querySelector('[data-final-state-image]');
const finalStateEmpty = root.querySelector('[data-final-state-empty]');
const finalStateLabel = root.querySelector('[data-final-state-label]');
const finalCoreImage = root.querySelector('[data-final-core-image]');
const finalCoreEmpty = root.querySelector('[data-final-core-empty]');
const finalCoreLabel = root.querySelector('[data-final-core-label]');
const finalCoreText = root.querySelector('[data-final-core-text]');
const cartPreviewImageInput = root.querySelector('[data-cart-preview-image-input]');
const cartPreviewAltInput = root.querySelector('[data-cart-preview-alt-input]');
const coreRingRenderInput = root.querySelector('[data-core-ring-render-input]');
const sportInput = root.querySelector('[data-sport-input]');
const sportDropdown = root.querySelector('[data-sport-dropdown]');
const sportEmblemPreview = root.querySelector('[data-sport-emblem-preview]');
const sportEmblemGenderInput = root.querySelector('[data-sport-emblem-gender-input]');
const sportEmblemImageInput = root.querySelector('[data-sport-emblem-image-input]');
const sportEmblemHandleInput = root.querySelector('[data-sport-emblem-handle-input]');
const sportRingRenderInput = root.querySelector('[data-sport-ring-render-input]');
const sportGrid = root.querySelector('[data-sport-grid]');
const sportSearch = root.querySelector('[data-sport-search]');
const sportEmpty = root.querySelector('[data-sport-empty]');
const stateSelect = root.querySelector('[data-state-select]');
const stateInput = root.querySelector('[data-state-input]');
const stateImageInput = root.querySelector('[data-state-image-input]');
const stateImageTypeInput = root.querySelector('[data-state-image-type-input]');
const stateImageHandleInput = root.querySelector('[data-state-image-handle-input]');
const stateOriginalImageInput = root.querySelector('[data-state-original-image-input]');
const stateRingRenderInput = root.querySelector('[data-state-ring-render-input]');
const stateEmblems = root.querySelector('[data-state-emblems]');
const stateEmpty = root.querySelector('[data-state-empty]');
const stateName = root.querySelector('[data-state-name]');
const productVariants = Array.isArray(config.productVariants) ? config.productVariants : [];
const productOptionNames = Array.isArray(config.productOptionNames) ? config.productOptionNames : [];
const currencyCode = config.currencyCode || 'USD';
const productLabel = root.dataset.productLabel || 'Ring';
const totalSteps = steps.length;
const withGatewayStep = (url) => {
if (!url) return '';
try {
const nextUrl = new URL(url, window.location.origin);
nextUrl.searchParams.set('sr_style_gateway', '1');
return nextUrl.origin === window.location.origin
? `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`
: nextUrl.toString();
} catch (error) {
return url.includes('sr_style_gateway=1') ? url : `${url}${url.includes('?') ? '&' : '?'}sr_style_gateway=1`;
}
};
const normalizeGatewayCandidate = (value) => {
if (!value) return '';
try {
const candidate = new URL(value, window.location.origin);
if (candidate.origin !== window.location.origin) return '';
if (candidate.pathname === window.location.pathname) return '';
return withGatewayStep(`${candidate.pathname}${candidate.search}${candidate.hash}`);
} catch (error) {
return '';
}
};
const getGatewayUrl = () => {
const params = new URLSearchParams(window.location.search);
const returnTo = normalizeGatewayCandidate(params.get('sr_return_to'));
if (returnTo) {
sessionStorage.setItem('sr-main-style-selector-url', returnTo);
return returnTo;
}
const storedGatewayUrl = normalizeGatewayCandidate(sessionStorage.getItem('sr-main-style-selector-url'));
if (storedGatewayUrl) return storedGatewayUrl;
if (document.referrer) {
const referrerGatewayUrl = normalizeGatewayCandidate(document.referrer);
if (referrerGatewayUrl) return referrerGatewayUrl;
}
const configuredGatewayUrl = normalizeGatewayCandidate(root.dataset.gatewayUrl || '');
if (configuredGatewayUrl) return configuredGatewayUrl;
const fallbackGatewayUrl = normalizeGatewayCandidate(root.dataset.fallbackGatewayUrl || '');
if (fallbackGatewayUrl) return fallbackGatewayUrl;
return '';
};
let currentStep = 1;
let allowStepScroll = false;
let stateUiInitialized = false;
let sportUiInitialized = false;
const routeParams = new URLSearchParams(window.location.search);
const routedStyleKey = String(routeParams.get('sr_selected_style') || '').trim().toLowerCase();
const hasCollectiveStyleRoute = root.dataset.builderType === 'fashion_band' && Boolean(routedStyleKey);
const getBuilderTopOffset = () => {
const candidates = Array.from(document.querySelectorAll(
'#shopify-section-header, sticky-header, .header-wrapper, .shopify-section-header-sticky, .section-header'
));
let offset = 0;
candidates.forEach((element) => {
if (!element || !element.getBoundingClientRect) return;
const styles = window.getComputedStyle(element);
const rect = element.getBoundingClientRect();
const isPinned = styles.position === 'fixed' || styles.position === 'sticky';
if (isPinned && rect.bottom > 0 && rect.top <= 2) {
offset = Math.max(offset, rect.bottom);
}
});
return Math.max(0, Math.round(offset));
};
const scrollBuilderToTop = () => {
if (!allowStepScroll) return;
requestAnimationFrame(() => {
requestAnimationFrame(() => {
const headerOffset = getBuilderTopOffset();
const top = window.scrollY + root.getBoundingClientRect().top - headerOffset - 8;
window.scrollTo({
top: Math.max(0, top),
behavior: 'smooth'
});
});
});
};
const states = [
['Alabama', 'AL'], ['Alaska', 'AK'], ['Arizona', 'AZ'], ['Arkansas', 'AR'],
['California', 'CA'], ['Colorado', 'CO'], ['Connecticut', 'CT'], ['Delaware', 'DE'],
['Florida', 'FL'], ['Georgia', 'GA'], ['Hawaii', 'HI'], ['Idaho', 'ID'],
['Illinois', 'IL'], ['Indiana', 'IN'], ['Iowa', 'IA'], ['Kansas', 'KS'],
['Kentucky', 'KY'], ['Louisiana', 'LA'], ['Maine', 'ME'], ['Maryland', 'MD'],
['Massachusetts', 'MA'], ['Michigan', 'MI'], ['Minnesota', 'MN'], ['Mississippi', 'MS'],
['Missouri', 'MO'], ['Montana', 'MT'], ['Nebraska', 'NE'], ['Nevada', 'NV'],
['New Hampshire', 'NH'], ['New Jersey', 'NJ'], ['New Mexico', 'NM'], ['New York', 'NY'],
['North Carolina', 'NC'], ['North Dakota', 'ND'], ['Ohio', 'OH'], ['Oklahoma', 'OK'],
['Oregon', 'OR'], ['Pennsylvania', 'PA'], ['Rhode Island', 'RI'], ['South Carolina', 'SC'],
['South Dakota', 'SD'], ['Tennessee', 'TN'], ['Texas', 'TX'], ['Utah', 'UT'],
['Vermont', 'VT'], ['Virginia', 'VA'], ['Washington', 'WA'], ['West Virginia', 'WV'],
['Wisconsin', 'WI'], ['Wyoming', 'WY']
];
const stateOptions = (config.stateOptions || []).filter((item) =>
(item.stateName || item.stateCode) &&
(
item.title ||
item.type ||
item.image ||
item.goldRingRender ||
item.silverRingRender ||
item.phantomRingRender ||
item.athenaGoldRingRender ||
item.athenaSilverRingRender ||
item.athenaPhantomRingRender ||
item.apolloGoldRingRender ||
item.apolloSilverRingRender ||
item.apolloPhantomRingRender ||
item.signetGoldRingRender ||
item.signetSilverRingRender ||
item.signetPhantomRingRender
)
);
const hasMetaStateOptions = stateOptions.length > 0;
const sportEmblemOptions = (config.sportEmblemOptions || []).filter((item) => item.sportName);
const hasMetaSportOptions = sportEmblemOptions.length > 0;
const fallbackSports = [
['Archery', '➶'], ['Auto Racing', '🏁'], ['Badminton', '◒'], ['Baseball', '⚾'],
['Basketball', '🏀'], ['Billiards', '◉'], ['Bodybuilding', '◆'], ['Bowling', '🎳'],
['Boxing', '🥊'], ['Bull Riding', '★'], ['Cheer', '✦', 'coed'], ['Chess', '♟'],
['Cricket', '◒'], ['Cross Country', '〽'], ['Curling', '◉'], ['Cycling', '◯'],
['Dance', '♪'], ['Darts', '◎'], ['Disc Golf', '◉'], ['Diving', '≈'],
['Equestrian', '♞'], ['Esports', '⌘'], ['Fencing', '⚔'], ['Field Hockey', '◒'],
['Figure Skating', '✧', 'coed'], ['Fishing', '≈'], ['Flag Football', '◇'], ['Football', '🏈'],
['Golf', '⛳'], ['Gymnastics', '✦'], ['Handball', '◉'], ['Hockey', '◒'],
['Hunting', '⌖'], ['Ice Hockey', '◒'], ['Jiu-Jitsu', '◆'], ['Judo', '◆'],
['Karate', '◆'], ['Kickball', '◉'], ['Lacrosse', '◒'], ['Marathon', '〽'],
['Martial Arts', '◆'], ['Motocross', '⚑'], ['Olympics', '★'], ['Pickleball', '◒'],
['Powerlifting', '▰'], ['Racquetball', '◒'], ['Rifle', '⌖'], ['Robotics', '⚙'],
['Rodeo', '★'], ['Rowing', '≈'], ['Rugby', '◇'], ['Sailing', '△'],
['Skateboarding', '▬'], ['Skiing', '⟋'], ['Snowboarding', '▬'], ['Soccer', '⚽'],
['Softball', '🥎'], ['Speed Skating', '✧'], ['Squash', '◒'], ['Surfing', '≈'],
['Swimming', '≈'], ['Table Tennis', '◉'], ['Taekwondo', '◆'], ['Tennis', '🎾'],
['Track & Field', '〽'], ['Triathlon', '△'], ['Twirling', '✦'], ['Ultimate Frisbee', '◉'],
['Volleyball', '🏐'], ['Water Polo', '◉'], ['Weightlifting', '▰'], ['Wrestling', '◆'],
['Color Guard', '⚑'], ['Dance Team', '♪'], ['Drill Team', '✦'], ['Marching Band', '♫'],
['Special Olympics', '★']
];
const hardcodedSportTypes = [
{ name: 'Archery', genders: ['general'] },
{ name: 'Auto Racing', genders: ['general'] },
{ name: 'Badminton', genders: ['female', 'male'] },
{ name: 'Baseball', genders: ['general'] },
{ name: 'Basketball', genders: ['female', 'male'] },
{ name: 'Billiards', genders: ['general'] },
{ name: 'Bodybuilding', genders: ['general'] },
{ name: 'Bowling', genders: ['general'] },
{ name: 'Boxing', genders: ['general'] },
{ name: 'Bull Riding', genders: ['general'] },
{ name: 'Cheer', genders: ['female', 'coed'] },
{ name: 'Chess', genders: ['general'] },
{ name: 'Color Guard', genders: ['general'] },
{ name: 'Cricket', genders: ['general'] },
{ name: 'Cross Country', genders: ['female', 'male'] },
{ name: 'Cycling', genders: ['general'] },
{ name: 'Dance', genders: ['general'] },
{ name: 'Darts', genders: ['general'] },
{ name: 'Disc Golf', genders: ['general'] },
{ name: 'Dive', genders: ['female', 'male'] },
{ name: 'Drill Team', genders: ['general'] },
{ name: 'E Sports', genders: ['general'] },
{ name: 'Equestrian', genders: ['general'] },
{ name: 'Fencing', genders: ['general'] },
{ name: 'Field Hockey', genders: ['female', 'male'] },
{ name: 'Figure Skating', genders: ['coed', 'female', 'male'] },
{ name: 'Fishing', genders: ['general'] },
{ name: 'Flag Football', genders: ['female', 'male'] },
{ name: 'Football', genders: ['general'] },
{ name: 'Golf', genders: ['female', 'male'] },
{ name: 'Gymnastics', genders: ['female', 'male'] },
{ name: 'Handball', genders: ['female', 'male'] },
{ name: 'Hockey', genders: ['female', 'male'] },
{ name: 'Hunting', genders: ['general'] },
{ name: 'Jiu Jitsu', genders: ['female', 'male'] },
{ name: 'Judo', genders: ['female'] }
];
const sportGenderOrder = ['female', 'male', 'coed', 'general'];
const sportSuffixPattern = /\s*[-–—]\s*(M|F|Male|Female|Men|Mens|Men's|Women|Womens|Women's|Girls|Boys|Coed|Co-Ed|Co Ed|General|All Girls)\s*$/i;
const cleanSportName = (value) => {
let cleaned = String(value || '')
.replace(/\([^)]*\)/g, '')
.replace(/\s+/g, ' ')
.trim();
let previous = '';
while (cleaned && cleaned !== previous) {
previous = cleaned;
cleaned = cleaned
.replace(sportSuffixPattern, '')
.replace(/\s+/g, ' ')
.trim();
}
return cleaned;
};
const canonicalSportKey = (value) => {
const rawCompact = String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
const key = cleanSportName(value)
.toLowerCase()
.replace(/&/g, 'and')
.replace(/[^a-z0-9]+/g, ' ')
.replace(/\s+/g, ' ')
.trim();
const compact = key.replace(/\s+/g, '');
if (rawCompact.includes('cheerleading') || rawCompact === 'cheer' || rawCompact === 'cheerallgirls' || rawCompact === 'cheercoed') return 'cheer';
if (compact.includes('cheerleading') || compact === 'cheer') return 'cheer';
if (compact === 'esports' || compact === 'esport') return 'e sports';
if (compact === 'diving' || compact === 'dive') return 'dive';
if (compact === 'jiujitsu' || compact === 'jiujutsu') return 'jiu jitsu';
if (compact === 'crosscountry') return 'cross country';
if (compact === 'fieldhockey') return 'field hockey';
if (compact === 'flagfootball') return 'flag football';
if (compact === 'autoracing') return 'auto racing';
if (compact === 'discgolf') return 'disc golf';
return key;
};
const hardcodedSportConfigFor = (sportName) => {
const key = canonicalSportKey(sportName);
return hardcodedSportTypes.find((item) => canonicalSportKey(item.name) === key) || null;
};
const displaySportName = (sportName) => {
const config = hardcodedSportConfigFor(sportName);
return config ? config.name : cleanSportName(sportName);
};
const genderFromSportName = (value) => {
const raw = String(value || '');
const rawCompact = raw.toLowerCase().replace(/[^a-z0-9]+/g, '');
if (rawCompact.includes('allgirls') || rawCompact.includes('girlsonly')) return 'female';
if (rawCompact.includes('coed')) return 'coed';
const match = raw.match(sportSuffixPattern);
if (!match) return '';
const suffix = match[1].toLowerCase().replace(/[\s-]+/g, '');
if (suffix === 'f' || suffix === 'female' || suffix === 'women' || suffix === 'womens' || suffix === "women's" || suffix === 'girls' || suffix === 'allgirls') return 'female';
if (suffix === 'm' || suffix === 'male' || suffix === 'men' || suffix === 'mens' || suffix === "men's" || suffix === 'boys') return 'male';
if (suffix === 'coed') return 'coed';
if (suffix === 'general') return 'general';
return '';
};
const normalizeSportGender = (value, sportName = '') => {
const suffixGender = genderFromSportName(sportName);
const raw = Array.isArray(value) ? value.join(' ') : String(value || '');
const normalized = raw.toLowerCase().trim();
const compactGender = normalized.replace(/[^a-z0-9]+/g, '');
if (compactGender.includes('allgirls') || normalized.includes('female') || normalized === 'f' || normalized.includes('all girls') || normalized.includes('women') || normalized.includes('girls')) return 'female';
if (normalized.includes('male') || normalized === 'm' || normalized.includes('men') || normalized.includes('boys')) return 'male';
if (normalized.includes('coed') || normalized.includes('co-ed') || normalized.includes('co ed')) return 'coed';
if (normalized.includes('general')) return 'general';
return suffixGender || 'general';
};
const sportGenderCode = (gender) => gender === 'female' ? 'F' : gender === 'male' ? 'M' : gender === 'coed' ? 'Coed' : '';
const sportGenderName = (gender) => gender === 'female' ? 'Female' : gender === 'male' ? 'Male' : gender === 'coed' ? 'Coed' : 'General';
const getSportBaseName = (value) => displaySportName(value);
const makeSportLabel = (baseName, gender) => {
const code = sportGenderCode(gender);
return code ? `${baseName} - ${code}` : baseName;
};
const normalizeSportItem = (item) => {
const baseName = displaySportName(item.sportName || item.baseName || item.name || '');
const gender = normalizeSportGender(item.gender, item.sportName || item.baseName || item.name || '');
return {
baseName,
gender,
genderName: sportGenderName(gender),
label: makeSportLabel(baseName, gender),
icon: item.icon || '★',
imageUrl: item.image || item.imageUrl || '',
goldRingRender: item.goldRingRender || '',
silverRingRender: item.silverRingRender || '',
phantomRingRender: item.phantomRingRender || '',
athenaGoldRingRender: item.athenaGoldRingRender || '',
athenaSilverRingRender: item.athenaSilverRingRender || '',
athenaPhantomRingRender: item.athenaPhantomRingRender || '',
apolloGoldRingRender: item.apolloGoldRingRender || '',
apolloSilverRingRender: item.apolloSilverRingRender || '',
apolloPhantomRingRender: item.apolloPhantomRingRender || '',
signetGoldRingRender: item.signetGoldRingRender || '',
signetSilverRingRender: item.signetSilverRingRender || '',
signetPhantomRingRender: item.signetPhantomRingRender || '',
altText: item.altText || `${baseName} ${sportGenderName(gender)} sport emblem`,
handle: item.handle || ''
};
};
const fallbackSportConfigFor = (sportName) => {
const key = canonicalSportKey(sportName);
const configured = hardcodedSportConfigFor(sportName);
if (configured) return { ...configured, icon: '★' };
const fallback = fallbackSports.find((item) => canonicalSportKey(item[0]) === key);
if (!fallback) return null;
return {
name: fallback[0],
genders: [normalizeSportGender(fallback[2] || 'general', fallback[0])],
icon: fallback[1] || '★'
};
};
const getAllSportOptions = () => {
const metaItems = sportEmblemOptions
.map(normalizeSportItem)
.filter((item) => item.baseName);
if (metaItems.length) return metaItems;
return fallbackSports.flatMap((fallback) => {
const config = fallbackSportConfigFor(fallback[0]);
if (!config) return [];
return config.genders.map((gender) => normalizeSportItem({
sportName: config.name,
gender,
icon: config.icon || fallback[1] || '★'
}));
});
};
const getSportOptions = () => {
const registry = new Map();
const addSport = (name, icon = '★') => {
const displayName = displaySportName(name);
const key = canonicalSportKey(displayName);
if (!key || registry.has(key)) return;
registry.set(key, {
baseName: displayName,
label: displayName,
gender: 'dropdown',
genderName: '',
icon,
imageUrl: '',
altText: `${displayName} sport`,
handle: ''
});
};
fallbackSports.forEach((item) => addSport(item[0], item[1] || '★'));
hardcodedSportTypes.forEach((item) => addSport(item.name));
sportEmblemOptions.forEach((item) => addSport(item.sportName));

const hiddenSportKeys = new Set(['curling', 'mixed martial arts']);
const sports = Array.from(registry.values()).filter((item) => {
const key = canonicalSportKey(item.baseName);
return key && !hiddenSportKeys.has(key);
});

return sports.sort((a, b) => {
const aKey = canonicalSportKey(a.baseName);
const bKey = canonicalSportKey(b.baseName);
if (aKey === 'wrestling' && bKey !== 'wrestling') return 1;
if (bKey === 'wrestling' && aKey !== 'wrestling') return -1;
return a.baseName.localeCompare(b.baseName, undefined, { sensitivity: 'base' });
});
};
const emblemsForSport = (sportName) => {
const selectedKey = canonicalSportKey(sportName);
const found = [];
const seen = new Set();
getAllSportOptions().forEach((item) => {
if (canonicalSportKey(item.baseName) !== selectedKey) return;
const key = `${item.gender}|${item.handle}|${item.imageUrl}|${item.label}`.toLowerCase();
if (seen.has(key)) return;
seen.add(key);
found.push(item);
});
if (!found.length) {
const config = fallbackSportConfigFor(sportName);
if (config) {
config.genders.forEach((gender) => found.push(normalizeSportItem({ sportName: config.name, gender, icon: config.icon || '★' })));
}
}
return found.sort((a, b) => {
const aOrder = sportGenderOrder.indexOf(a.gender);
const bOrder = sportGenderOrder.indexOf(b.gender);
return (aOrder === -1 ? 99 : aOrder) - (bOrder === -1 ? 99 : bOrder);
});
};
const findSportOptionByLabel = (label) => {
const value = String(label || '').trim();
if (!value) return null;
return getAllSportOptions().find((item) => item.label === value)
|| getSportOptions().find((item) => item.label === value)
|| null;
};
const setSelectedSportOption = (selectedOption, refresh = true) => {
if (sportInput) sportInput.value = selectedOption ? selectedOption.label : '';
if (sportEmblemGenderInput) sportEmblemGenderInput.value = selectedOption ? selectedOption.genderName : '';
if (sportEmblemImageInput) sportEmblemImageInput.value = selectedOption ? selectedOption.imageUrl : '';
if (sportEmblemHandleInput) sportEmblemHandleInput.value = selectedOption ? selectedOption.handle : '';
selectedSportEmblemPreview = selectedOption || null;
syncSelectedEmblemRenderInputs();
if (!selectedOption) clearActiveEmblemPreview('sport', { refresh });
};
const renderSportEmblemCards = (selectedSport, options, selectedLabel = '') => {
if (!sportEmblemPreview) return;
if (!selectedSport) {
sportEmblemPreview.hidden = true;
sportEmblemPreview.innerHTML = '';
return;
}
if (!options.length) {
sportEmblemPreview.hidden = false;
sportEmblemPreview.innerHTML = `<p class="sr-ring-builder__empty">No sport emblem found for ${escapeHtml(selectedSport)} yet.</p>`;
return;
}
sportEmblemPreview.hidden = false;
warmEmblemRenderOptions(options, 'sport');
sportEmblemPreview.innerHTML = `
<div class="sr-ring-builder__sport-emblem-grid">
${options.map((option) => {
const fallbackText = option.baseName.slice(0, 2).toUpperCase();
const isSelected = selectedLabel === option.label;
return `
<button class="sr-ring-builder__sport-emblem-card${isSelected ? ' is-selected' : ''}" type="button" data-sport-emblem-card data-sport-label="${escapeHtml(option.label)}" aria-pressed="${isSelected}" aria-label="Select ${escapeHtml(option.label)} emblem">
<span class="sr-ring-builder__sport-emblem-media">
${option.imageUrl ? `<img src="${escapeHtml(option.imageUrl)}" alt="${escapeHtml(option.altText)}" loading="lazy" decoding="async" width="640" height="640">` : `<span>${escapeHtml(fallbackText)}</span>`}
</span>
<span class="sr-ring-builder__sport-emblem-copy">
<strong>${escapeHtml(option.genderName)} Emblem</strong>
<small>${escapeHtml(option.label)}</small>
</span>
<span class="sr-ring-builder__emblem-expand" data-sport-emblem-expand aria-label="Expand ${escapeHtml(option.label)} emblem">
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M21 3l-8 8"/><path d="M9 21H3v-6"/><path d="M3 21l8-8"/></svg>
</span>
</button>
`;
}).join('')}
</div>
`;
};
const updateSelectedSportEmblem = () => {
const selectedSport = sportDropdown ? sportDropdown.value : getSportBaseName(sportInput ? sportInput.value : '');
const options = selectedSport ? emblemsForSport(selectedSport) : [];
let selectedOption = sportInput && sportInput.value
? options.find((item) => item.label === sportInput.value)
: null;
if (!selectedOption && options.length === 1) selectedOption = options[0];
if (!selectedOption && (!sportInput || !sportInput.value || !options.some((item) => item.label === sportInput.value))) {
setSelectedSportOption(null);
}
if (selectedOption) {
setSelectedSportOption(selectedOption);
activateEmblemPreview(selectedOption, 'sport');
}
renderSportEmblemCards(selectedSport, options, selectedOption ? selectedOption.label : '');
};
const populateSportDropdown = (preferredBaseName = '') => {
if (!sportDropdown) return;
const currentBaseName = displaySportName(preferredBaseName || sportDropdown.value || (sportInput ? sportInput.value : ''));
sportDropdown.innerHTML = '<option value="">Select your sport</option>';
const options = getSportOptions();
options.forEach((sport) => {
const option = document.createElement('option');
option.value = sport.baseName;
option.textContent = sport.baseName;
option.dataset.baseSport = sport.baseName;
sportDropdown.appendChild(option);
});
const nextOption = currentBaseName ? options.find((sport) => canonicalSportKey(sport.baseName) === canonicalSportKey(currentBaseName)) : null;
if (nextOption) {
sportDropdown.value = nextOption.baseName;
} else {
sportDropdown.value = '';
setSelectedSportOption(null);
}
updateSelectedSportEmblem();
};
const selectSportEmblemOption = (label) => {
const selectedSport = sportDropdown ? sportDropdown.value : '';
const selectedOption = emblemsForSport(selectedSport).find((item) => item.label === label) || findSportOptionByLabel(label);
if (!selectedOption) return;
setSelectedSportOption(selectedOption);
activateEmblemPreview(selectedOption, 'sport');
renderSportEmblemCards(selectedSport, emblemsForSport(selectedSport), selectedOption.label);
if (typeof updateStyleSpecificProperties === 'function') updateStyleSpecificProperties();
clearError();
};
const escapeHtml = (value) => String(value)
.replaceAll('&', '&amp;')
.replaceAll('<', '&lt;')
.replaceAll('>', '&gt;')
.replaceAll('"', '&quot;')
.replaceAll("'", '&#039;');
let selectedStateEmblemPreview = null;
let selectedSportEmblemPreview = null;
let summaryUpdateInProgress = false;
const getSelectedRingToneKey = () => {
const toneField =
form.querySelector('input[name="sr_ring_color"]:checked') ||
form.querySelector('[data-tone-choice]:checked');
const tone = String(toneField ? toneField.value : '').toLowerCase();
if (tone.includes('phantom') || tone.includes('black')) return 'phantom';
if (tone.includes('silver')) return 'silver';
return 'gold';
};
const getRingRenderForTone = (option) => {
if (!option) return '';
const toneKey = getSelectedRingToneKey();
const styleKey = typeof selectedStyleKey === 'function' ? selectedStyleKey() : '';

if (styleKey === 'athena') {
if (toneKey === 'phantom') return option.athenaPhantomRingRender || '';
if (toneKey === 'silver') return option.athenaSilverRingRender || '';
return option.athenaGoldRingRender || '';
}

if (styleKey === 'apollo') {
if (toneKey === 'phantom') return option.apolloPhantomRingRender || '';
if (toneKey === 'silver') return option.apolloSilverRingRender || '';
return option.apolloGoldRingRender || '';
}

if (styleKey === 'hermes') {
if (toneKey === 'phantom') return option.signetPhantomRingRender || '';
if (toneKey === 'silver') return option.signetSilverRingRender || '';
return option.signetGoldRingRender || '';
}

if (toneKey === 'phantom') {
return option.phantomRingRender || option.silverRingRender || option.goldRingRender || option.imageUrl || '';
}
if (toneKey === 'silver') {
return option.silverRingRender || option.goldRingRender || option.phantomRingRender || option.imageUrl || '';
}
return option.goldRingRender || option.silverRingRender || option.phantomRingRender || option.imageUrl || '';
};
const syncSelectedEmblemRenderInputs = () => {
if (stateRingRenderInput) stateRingRenderInput.value = getRingRenderForTone(selectedStateEmblemPreview);
if (sportRingRenderInput) sportRingRenderInput.value = getRingRenderForTone(selectedSportEmblemPreview);
};
const stepNumberFor = (element) => Number(element?.closest('[data-step]')?.dataset.step || -1);
const getCurrentEmblemPreviewType = () => {
const stateStep = stepNumberFor(stateEmblems);
const sportStep = stepNumberFor(sportEmblemPreview || sportDropdown);
if (currentStep === stateStep) return 'state';
if (currentStep === sportStep) return 'sport';
return '';
};
const getActiveEmblemRenderData = () => {
syncSelectedEmblemRenderInputs();
const sourceType = getCurrentEmblemPreviewType();
const option = sourceType === 'state'
? selectedStateEmblemPreview
: sourceType === 'sport'
? selectedSportEmblemPreview
: null;
if (!option) return { imageUrl: '', altText: '', sourceType: '' };
const imageUrl = getRingRenderForTone(option);
const toneLabel = getSelectedRingToneKey();
const title = option.title || option.label || 'Selected emblem';
return {
imageUrl,
altText: `${title} engraved on ${toneLabel} ring`,
sourceType
};
};
const warmEmblemRenderOptions = () => {};
const activateEmblemPreview = (option, type) => {
if (!option) return;
if (type === 'state') selectedStateEmblemPreview = option;
if (type === 'sport') selectedSportEmblemPreview = option;
syncSelectedEmblemRenderInputs();
if (typeof updateImage === 'function') updateImage();
if (typeof updateSummary === 'function') updateSummary();
};
const clearActiveEmblemPreview = (type, { refresh = true } = {}) => {
if (!type || type === 'state') {
selectedStateEmblemPreview = null;
if (stateRingRenderInput) stateRingRenderInput.value = '';
}
if (!type || type === 'sport') {
selectedSportEmblemPreview = null;
if (sportRingRenderInput) sportRingRenderInput.value = '';
}
if (refresh && !summaryUpdateInProgress) {
if (typeof updateImage === 'function') updateImage();
if (typeof updateSummary === 'function') updateSummary();
}
};
const selectedStyle = () => form.querySelector('[data-style-choice]:checked') || form.querySelector('input[type="hidden"][data-style-choice]');
const selectedTone = () => form.querySelector('[data-tone-choice]:checked');
const selectedStyleKey = () => {
const style = selectedStyle();
return style ? String(style.dataset.styleKey || '').toLowerCase() : '';
};
const applyRoutedStyleSelection = () => {
if (!hasCollectiveStyleRoute) return false;
const choice = Array.from(form.querySelectorAll('[data-style-choice]')).find((input) => String(input.dataset.styleKey || '').toLowerCase() === routedStyleKey);
if (!choice) return false;
if (choice.type === 'radio') choice.checked = true;
return true;
};
const getExactThemePreviewImage = (styleKey = selectedStyleKey(), toneKey = '') => {
const normalizedStyle = String(styleKey || '').trim().toLowerCase();
const normalizedTone = String(toneKey || '').trim().toLowerCase();
if (!normalizedStyle || !normalizedTone) return '';
return String(root.getAttribute(`data-preview-${normalizedStyle}-${normalizedTone}`) || '').trim();
};
const styleNeedsSport = () => ['athena', 'apollo', 'hermes'].includes(selectedStyleKey());
const styleNeedsState = () => ['athena', 'hermes'].includes(selectedStyleKey());
const conditionalMatches = (condition) => {
if (!condition) return true;
if (condition === 'sport') return styleNeedsSport();
if (condition === 'state' || condition === 'state-image') return styleNeedsState();
return true;
};
const shouldUseStep = (stepNumber) => {
const step = steps.find((item) => Number(item.dataset.step) === Number(stepNumber));
if (!step) return false;
return conditionalMatches(step.dataset.conditionalStep || '');
};
const activeStepNumbers = () => steps
.map((step) => Number(step.dataset.step))
.filter((stepNumber) => shouldUseStep(stepNumber))
.filter((stepNumber) => !(hasCollectiveStyleRoute && stepNumber === 1));
const normalizeStep = (stepNumber, direction = 1) => {
const active = activeStepNumbers();
if (!active.length) return 1;
if (active.includes(stepNumber)) return stepNumber;
if (direction < 0) {
return active.slice().reverse().find((item) => item < stepNumber) || active[0];
}
return active.find((item) => item > stepNumber) || active[active.length - 1];
};
const nextStepNumber = (fromStep) => {
const active = activeStepNumbers();
return active.find((item) => item > fromStep) || fromStep;
};
const previousStepNumber = (fromStep) => {
const active = activeStepNumbers().slice().reverse();
return active.find((item) => item < fromStep) || fromStep;
};
const normalize = (value) => String(value || '')
.toLowerCase()
.replace(/[×]/g, 'x')
.replace(/&/g, 'and')
.replace(/[^a-z0-9]+/g, ' ')
.replace(/^the\s+/, '')
.trim();
const squeeze = (value) => normalize(value).replace(/\s+/g, '');
const dimensionSignature = (value) => {
const matches = String(value || '')
.toLowerCase()
.replace(/[×*]/g, 'x')
.match(/\d+(?:\.\d+)?\s*mm/g);
return matches ? matches.map((item) => item.replace(/\s+/g, '')).join('x') : '';
};
const dimensionsMatch = (a, b) => {
const left = dimensionSignature(a);
const right = dimensionSignature(b);
return Boolean(left && right && (left === right || left.replace(/x/g, '') === right.replace(/x/g, '')));
};
const uniqueList = (items) => Array.from(new Set(items.map(normalize).filter(Boolean)));
const variantValues = (variant) => {
const values = [];
if (variant.title) values.push(variant.title);
if (variant.option1) values.push(variant.option1);
if (variant.option2) values.push(variant.option2);
if (variant.option3) values.push(variant.option3);
if (Array.isArray(variant.options)) values.push(...variant.options);
return values.filter(Boolean);
};
const variantNormalizedValues = (variant) => variantValues(variant).map(normalize);
const variantText = (variant) => normalize(variantValues(variant).join(' '));
const variantSqueezedText = (variant) => squeeze(variantValues(variant).join(' '));
const hasAlias = (variant, aliases) => {
const values = variantNormalizedValues(variant);
const joined = ` ${variantText(variant)} `;
return aliases.some((alias) => {
const item = normalize(alias);
if (!item) return false;
return values.some((value) => value === item || value.includes(item) || item.includes(value)) || joined.includes(` ${item} `);
});
};
const toneAliases = (toneValue) => {
const tone = normalize(toneValue);
const aliases = [toneValue, tone];
if (tone.includes('phantom')) {
aliases.push('phantom', 'phantom on silver', 'phantom on phantom', 'black', 'black on silver', 'black silver');
return uniqueList(aliases);
}
if (tone.includes('silver')) {
aliases.push('silver', 'silver on silver', 'white gold');
return uniqueList(aliases);
}
if (tone.includes('gold')) {
aliases.push('gold', 'gold on gold', 'yellow gold');
return uniqueList(aliases);
}
return uniqueList(aliases);
};
const styleAliases = (style) => {
if (!style) return [];
const aliases = [style.value, style.dataset.styleKey, style.dataset.styleSize];
const key = normalize(style.dataset.styleKey || style.value);
if (key.includes('athena') || key.includes('chesapeake')) {
aliases.push('athena', 'the athena', 'chesapeake', 'the chesapeake', '7mm', '7 mm');
}
if (key.includes('apollo') || key.includes('appolo') || key.includes('acadia')) {
aliases.push(
'apollo',
'appolo',
'the apollo',
'the appolo',
'acadia',
'the acadia',
'15mm x 15mm',
'15 mm x 15 mm'
);
}
if (key.includes('artemis') || key.includes('denali')) {
aliases.push(
'artemis',
'the artemis',
'denali',
'the denali',
'medium',
'18mm x 15mm',
'18 mm x 15 mm',
'20mm x 17mm',
'20 mm x 17 mm'
);
}
if (key.includes('hermes')) aliases.push('hermes', 'the hermes', 'large', '21mm x 21mm', '21 mm x 21 mm');
return uniqueList(aliases);
};
const toneScore = (variant, toneValue) => {
const tone = normalize(toneValue);
if (!tone) return 0;
const values = variantNormalizedValues(variant);
const joined = ` ${variantText(variant)} `;
if (tone.includes('phantom')) {
if (values.some((value) => value === 'phantom' || value === 'phantom on silver' || value === 'phantom on phantom')) return 80;
if (joined.includes(' phantom ') || joined.includes(' black ')) return 70;
return 0;
}
if (tone.includes('silver')) {
if (values.some((value) => value === 'silver' || value === 'silver on silver')) return 80;
if (joined.includes(' silver ') && !joined.includes(' phantom ') && !joined.includes(' black ')) return 70;
return 0;
}
if (tone.includes('gold')) {
if (values.some((value) => value === 'gold' || value === 'yellow gold' || value === 'gold on gold')) return 80;
if (joined.includes(' gold ')) return 70;
return 0;
}
return hasAlias(variant, toneAliases(toneValue)) ? 50 : 0;
};
const styleScore = (variant, style) => {
if (!style) return 0;
const key = normalize(style.dataset.styleKey || style.value);
const selectedValue = normalize(style.value);
const selectedSize = normalize(style.dataset.styleSize || '');
const values = variantNormalizedValues(variant);
const joined = ` ${variantText(variant)} `;
const compact = variantSqueezedText(variant);
let score = 0;
if (values.some((value) => value === selectedValue || value === key)) score = Math.max(score, 120);
if (joined.includes(` ${key} `)) score = Math.max(score, 110);
if (selectedSize && values.some((value) => value === selectedSize || dimensionsMatch(value, selectedSize))) score = Math.max(score, 100);
if (selectedSize && (compact.includes(squeeze(selectedSize)) || dimensionsMatch(variantValues(variant).join(' '), selectedSize))) score = Math.max(score, 95);
if (key.includes('athena') || key.includes('chesapeake')) {
if (joined.includes(' athena ') || joined.includes(' chesapeake ')) score = Math.max(score, 110);
if (values.some((value) => value === '7mm' || value === '7 mm') || compact.includes('7mm')) score = Math.max(score, 90);
}
if (key.includes('apollo') || key.includes('appolo') || key.includes('acadia')) {
if (joined.includes(' apollo ') || joined.includes(' appolo ') || joined.includes(' acadia ')) score = Math.max(score, 110);
if (compact.includes('15mmx15mm') || dimensionsMatch(variantValues(variant).join(' '), '15mm x 15mm')) score = Math.max(score, 95);
}
if (key.includes('artemis') || key.includes('denali')) {
if (joined.includes(' artemis ') || joined.includes(' denali ')) score = Math.max(score, 110);
if (joined.includes(' medium ')) score = Math.max(score, 90);
if (
compact.includes('18mmx15mm') ||
compact.includes('20mmx17mm') ||
dimensionsMatch(variantValues(variant).join(' '), '18mm x 15mm') ||
dimensionsMatch(variantValues(variant).join(' '), '20mm x 17mm')
) score = Math.max(score, 95);
}
if (key.includes('hermes')) {
if (joined.includes(' hermes ')) score = Math.max(score, 110);
if (joined.includes(' large ')) score = Math.max(score, 90);
if (compact.includes('21mmx21mm')) score = Math.max(score, 95);
}
return score;
};
const pickSingleAvailable = (variants) => {
const clean = variants.filter(Boolean);
const available = clean.filter((variant) => variant.available !== false);
if (available.length === 1) return available[0];
if (clean.length === 1) return clean[0];
return null;
};
const variantByToneIndex = (tone) => {
const index = Number(tone && tone.dataset ? tone.dataset.toneIndex : -1);
if (!Number.isInteger(index) || index < 0) return null;
const activeVariants = productVariants.filter((variant) => variant.available !== false);
if (activeVariants.length >= 3 && activeVariants[index]) return activeVariants[index];
if (productVariants.length >= 3 && productVariants[index]) return productVariants[index];
return null;
};
const styleOrderIndex = (style) => {
const styleKey = normalize(style && style.dataset ? style.dataset.styleKey : '');
const styleOrder = ['athena', 'apollo', 'artemis'];
return styleOrder.findIndex((key) => styleKey.includes(key));
};
const variantByToneGroupStyleIndex = (style, toneMatches) => {
const styleIndex = styleOrderIndex(style);
const clean = toneMatches.filter(Boolean);
const available = clean.filter((variant) => variant.available !== false);
const source = available.length >= 3 ? available : clean;
if (styleIndex < 0 || source.length < 3) return null;
return source[styleIndex] || null;
};
const variantByStyleGroupToneIndex = (tone, styleMatches) => {
const toneIndex = Number(tone && tone.dataset ? tone.dataset.toneIndex : -1);
const clean = styleMatches.filter(Boolean);
const available = clean.filter((variant) => variant.available !== false);
const source = available.length >= 3 ? available : clean;
if (toneIndex < 0 || source.length < 3) return null;
return source[toneIndex] || null;
};
const variantByStyleToneIndex = (style, tone) => {
const toneIndex = Number(tone && tone.dataset ? tone.dataset.toneIndex : -1);
const styleIndex = styleOrderIndex(style);
if (styleIndex < 0 || toneIndex < 0) return null;
const variants = productVariants.filter(Boolean);
const availableVariants = variants.filter((variant) => variant.available !== false);
const source = availableVariants.length >= 9 ? availableVariants : variants;
if (source.length < 9) return null;
const firstOptionName = normalize(productOptionNames && productOptionNames[0] ? productOptionNames[0] : '');
const secondOptionName = normalize(productOptionNames && productOptionNames[1] ? productOptionNames[1] : '');
const toneFirst = firstOptionName.includes('tone') || firstOptionName.includes('color') || firstOptionName.includes('metal');
const styleFirst = firstOptionName.includes('style') || firstOptionName.includes('size') || secondOptionName.includes('tone') || secondOptionName.includes('color') || secondOptionName.includes('metal');
const styleFirstIndex = (styleIndex * 3) + toneIndex;
const toneFirstIndex = (toneIndex * 3) + styleIndex;
const preferredIndex = toneFirst && !styleFirst ? toneFirstIndex : styleFirstIndex;
const alternateIndex = preferredIndex === styleFirstIndex ? toneFirstIndex : styleFirstIndex;
return source[preferredIndex] || source[alternateIndex] || null;
};
const bestScoredVariant = (variants) => {
if (!variants.length) return null;
const sorted = variants.slice().sort((a, b) => {
if ((a.variant.available !== false) !== (b.variant.available !== false)) {
return a.variant.available !== false ? -1 : 1;
}
return b.score - a.score;
});
return sorted[0].variant || null;
};
const findProductOptionIndex = (keywords) => productOptionNames.findIndex((name) => {
const normalizedName = normalize(name);
return keywords.some((keyword) => normalizedName.includes(keyword));
});
const styleOptionIndex = findProductOptionIndex(['style', 'size', 'dimension', 'model']);
const toneOptionIndex = findProductOptionIndex(['tone', 'color', 'colour', 'metal', 'finish']);
const variantOptionAt = (variant, index) => {
if (index < 0 || !variant) return '';
if (Array.isArray(variant.options) && variant.options[index] !== undefined) return variant.options[index] || '';
return variant[`option${index + 1}`] || '';
};
const optionMatchesStyle = (value, style) => {
const normalizedValue = normalize(value);
if (!normalizedValue || !style) return false;
if (styleAliases(style).some((alias) => {
const normalizedAlias = normalize(alias);
return normalizedAlias && (normalizedValue === normalizedAlias || normalizedValue.includes(normalizedAlias) || normalizedAlias.includes(normalizedValue));
})) return true;
return dimensionsMatch(value, style.dataset.styleSize || '');
};
const optionMatchesTone = (value, toneValue) => toneScore({ title: String(value || ''), options: [String(value || '')] }, toneValue) > 0;
const chooseDeterministicVariant = (variants) => {
const clean = variants.filter(Boolean);
const available = clean.filter((variant) => variant.available !== false);
if (available.length === 1) return available[0];
if (clean.length === 1) return clean[0];
return null;
};
const findSelectedVariant = () => {
const style = selectedStyle();
const tone = selectedTone();
if (!style || !tone) return null;
const isSignet = root.dataset.builderType === 'signet';
if (productVariants.length === 1 && styleOptionIndex < 0 && toneOptionIndex < 0) {
return productVariants[0];
}
let candidates = productVariants.slice();
if (toneOptionIndex >= 0) {
candidates = candidates.filter((variant) => optionMatchesTone(variantOptionAt(variant, toneOptionIndex), tone.value));
} else {
candidates = candidates.filter((variant) => toneScore(variant, tone.value) > 0);
}
if (!isSignet) {
if (styleOptionIndex >= 0 && styleOptionIndex !== toneOptionIndex) {
candidates = candidates.filter((variant) => optionMatchesStyle(variantOptionAt(variant, styleOptionIndex), style));
} else {
const styleAwareCandidates = candidates.filter((variant) => styleScore(variant, style) > 0);
if (styleAwareCandidates.length || productVariants.length > 3) {
candidates = styleAwareCandidates;
}
}
}
let resolved = chooseDeterministicVariant(candidates);
if (resolved) return resolved;
if (!isSignet) {
const toneCandidates = productVariants.filter((variant) => {
if (toneOptionIndex >= 0) {
return optionMatchesTone(variantOptionAt(variant, toneOptionIndex), tone.value);
}
return toneScore(variant, tone.value) > 0;
});
resolved = chooseDeterministicVariant(toneCandidates);
if (resolved && productVariants.length <= 3) return resolved;
}
return null;
};
const formatMoney = (cents) => {
const amount = Number(cents || 0) / 100;
try {
return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode || 'USD' }).format(amount);
} catch (error) {
return `$${amount.toFixed(2)}`;
}
};
const showError = (message, field) => {
if (!errorBox) return;
errorBox.textContent = message;
errorBox.hidden = false;
if (field && field.focus && field.type !== 'hidden') field.focus({ preventScroll: true });
};
const clearError = () => {
if (!errorBox) return;
errorBox.hidden = true;
errorBox.textContent = '';
};
const getStateList = () => {
return states.map(([name, code]) => ({ name, code }));
};
const populateStateSelect = () => {
if (!stateSelect) return;
stateSelect.innerHTML = '<option value="">Pick your state</option>';
getStateList().forEach(({ name, code }) => {
const option = document.createElement('option');
option.value = name;
option.textContent = code ? `${name} (${code})` : name;
option.dataset.stateCode = code || '';
stateSelect.appendChild(option);
});
};
const getSelectedStateInfo = () => {
if (!stateSelect || !stateSelect.value) return null;
const selectedOption = stateSelect.options[stateSelect.selectedIndex];
return {
name: stateSelect.value,
code: selectedOption ? selectedOption.dataset.stateCode || '' : ''
};
};
const normalizeStateToken = (value) => String(value || '')
.trim()
.toLowerCase()
.replace(/[^a-z0-9]+/g, ' ')
.replace(/\s+/g, ' ')
.trim();
const canonicalStateKey = (nameValue, codeValue = '') => {
const normalizedName = normalizeStateToken(nameValue);
const normalizedCode = normalizeStateToken(codeValue).replace(/\s+/g, '');
const codeMatch = normalizedCode
? states.find(([, code]) => normalizeStateToken(code).replace(/\s+/g, '') === normalizedCode)
: null;
if (codeMatch) return codeMatch[1].toLowerCase();
const exactMatch = states.find(([name, code]) => {
const nameToken = normalizeStateToken(name);
const codeToken = normalizeStateToken(code);
return normalizedName === nameToken ||
normalizedName === codeToken ||
normalizedName === `${nameToken} ${codeToken}`;
});
if (exactMatch) return exactMatch[1].toLowerCase();
const containedMatch = states.find(([name, code]) => {
const nameToken = normalizeStateToken(name);
const codeToken = normalizeStateToken(code);
return normalizedName.includes(nameToken) ||
normalizedName.split(' ').includes(codeToken);
});
if (containedMatch) return containedMatch[1].toLowerCase();
return normalizedCode || normalizedName;
};
const optionsForState = (stateInfo) => {
if (!stateInfo || !hasMetaStateOptions) return [];
const selectedKey = canonicalStateKey(stateInfo.name, stateInfo.code);
return stateOptions
.filter((item) => canonicalStateKey(item.stateName, item.stateCode) === selectedKey)
.sort((a, b) => {
const aSort = Number(a.sortOrder || 999);
const bSort = Number(b.sortOrder || 999);
if (aSort !== bSort) return aSort - bSort;
return String(a.type || '').localeCompare(String(b.type || ''));
});
};
const resetStateImageSelection = (refresh = true) => {
if (stateImageInput) stateImageInput.value = '';
if (stateImageTypeInput) stateImageTypeInput.value = '';
if (stateImageHandleInput) stateImageHandleInput.value = '';
if (stateOriginalImageInput) stateOriginalImageInput.value = '';
if (stateRingRenderInput) stateRingRenderInput.value = '';
clearActiveEmblemPreview('state', { refresh });
if (stateEmblems) {
stateEmblems.querySelectorAll('[data-state-image]').forEach((item) => {
item.classList.remove('is-selected');
item.setAttribute('aria-pressed', 'false');
});
}
};
const renderStateEmblems = () => {
if (!stateEmblems) return;
const selectedState = getSelectedStateInfo();
if (!selectedState) {
stateEmblems.innerHTML = '';
stateEmblems.dataset.state = '';
if (stateName) stateName.textContent = 'your state';
if (stateEmpty) stateEmpty.hidden = true;
resetStateImageSelection();
return;
}
if (stateName) stateName.textContent = selectedState.name;
if (stateEmblems.dataset.state === selectedState.name && stateEmblems.children.length) return;
stateEmblems.dataset.state = selectedState.name;
resetStateImageSelection();
const metaOptions = optionsForState(selectedState);
if (hasMetaStateOptions) {
if (!metaOptions.length) {
stateEmblems.innerHTML = '';
if (stateEmpty) stateEmpty.hidden = false;
return;
}
if (stateEmpty) stateEmpty.hidden = true;
warmEmblemRenderOptions(metaOptions, 'state');
stateEmblems.innerHTML = metaOptions.map((option) => {
const title = option.title || `${selectedState.name} ${option.type || 'Image'}`;
const type = option.type || 'Image';
const altText = option.altText || title;
const fallbackCode = selectedState.code || selectedState.name.slice(0, 2).toUpperCase();
return `
<button
class="sr-ring-builder__emblem-button"
type="button"
data-state-image="${escapeHtml(title)}"
data-state-image-type="${escapeHtml(type)}"
data-state-image-handle="${escapeHtml(option.handle || '')}"
data-state-image-url="${escapeHtml(option.image || '')}"
data-state-render-gold="${escapeHtml(option.goldRingRender || '')}"
data-state-render-silver="${escapeHtml(option.silverRingRender || '')}"
data-state-render-phantom="${escapeHtml(option.phantomRingRender || '')}"
data-state-render-athena-gold="${escapeHtml(option.athenaGoldRingRender || '')}"
data-state-render-athena-silver="${escapeHtml(option.athenaSilverRingRender || '')}"
data-state-render-athena-phantom="${escapeHtml(option.athenaPhantomRingRender || '')}"
data-state-render-apollo-gold="${escapeHtml(option.apolloGoldRingRender || '')}"
data-state-render-apollo-silver="${escapeHtml(option.apolloSilverRingRender || '')}"
data-state-render-apollo-phantom="${escapeHtml(option.apolloPhantomRingRender || '')}"
data-state-render-signet-gold="${escapeHtml(option.signetGoldRingRender || '')}"
data-state-render-signet-silver="${escapeHtml(option.signetSilverRingRender || '')}"
data-state-render-signet-phantom="${escapeHtml(option.signetPhantomRingRender || '')}"
data-state-image-alt="${escapeHtml(altText)}"
aria-pressed="false"
>
<span class="sr-ring-builder__emblem-expand" data-emblem-expand aria-label="Expand ${escapeHtml(title)} image">
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M21 3l-8 8"/><path d="M9 21H3v-6"/><path d="M3 21l8-8"/></svg>
</span>
<span class="sr-ring-builder__state-emblem-image">
${option.image
? `<img src="${escapeHtml(option.image)}" alt="${escapeHtml(altText)}" loading="lazy" decoding="async" width="640" height="640">`
: `<span>${escapeHtml(fallbackCode)}</span>`
}
</span>
<strong title="${escapeHtml(title)}">${escapeHtml(title)}</strong>
<small class="sr-ring-builder__emblem-type">${escapeHtml(type)}</small>
</button>
`;
}).join('');
return;
}
if (stateEmpty) stateEmpty.hidden = true;
const abbreviation = selectedState.code || selectedState.name.slice(0, 2).toUpperCase();
const fallbacks = [
{ value: 'State Seal', label: 'Seal', className: 'seal' },
{ value: 'Championship Crest', label: 'Crest', className: 'crest' },
{ value: 'State Star Emblem', label: 'Star', className: 'star' }
];
stateEmblems.innerHTML = fallbacks.map((item) => `
<button class="sr-ring-builder__emblem-button" type="button" data-state-image="${escapeHtml(item.value)}" data-state-image-type="${escapeHtml(item.label)}" data-state-image-handle="" data-state-image-url="" data-state-image-alt="${escapeHtml(item.label)}" aria-pressed="false">
<span class="sr-ring-builder__emblem-expand" data-emblem-expand aria-label="Expand ${escapeHtml(item.label)} image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6"/><path d="M21 3l-8 8"/><path d="M9 21H3v-6"/><path d="M3 21l8-8"/></svg></span>
<span class="sr-ring-builder__state-emblem sr-ring-builder__state-emblem--${item.className}" aria-hidden="true">${escapeHtml(abbreviation)}</span>
<strong>${escapeHtml(item.label)}</strong>
</button>
`).join('');
};
let stateLightbox = null;
let stateLightboxItems = [];
let stateLightboxIndex = 0;
let stateLightboxReturnFocus = null;
const getStateEmblemButtons = () => stateEmblems ? Array.from(stateEmblems.querySelectorAll('[data-state-image]')) : [];
const getStateEmblemData = (button) => {
const img = button ? button.querySelector('.sr-ring-builder__state-emblem-image img') : null;
const fallbackText = button ? (button.querySelector('.sr-ring-builder__state-emblem')?.textContent || button.querySelector('.sr-ring-builder__state-emblem-image span')?.textContent || '').trim() : '';
return {
button,
title: button ? (button.dataset.stateImage || button.querySelector('strong')?.textContent || 'State image') : 'State image',
type: button ? (button.dataset.stateImageType || button.querySelector('.sr-ring-builder__emblem-type')?.textContent || 'Image') : 'Image',
imageUrl: button ? (button.dataset.stateImageUrl || img?.getAttribute('src') || '') : '',
altText: button ? (button.dataset.stateImageAlt || img?.getAttribute('alt') || button.dataset.stateImage || 'State image preview') : 'State image preview',
fallbackText: fallbackText || (getSelectedStateInfo()?.code || getSelectedStateInfo()?.name?.slice(0, 2) || 'SR').toUpperCase(),
select: button ? () => selectStateEmblemButton(button) : null
};
};
const selectStateEmblemButton = (button) => {
if (!button || !stateEmblems) return;
stateEmblems.querySelectorAll('[data-state-image]').forEach((item) => {
const selected = item === button;
item.classList.toggle('is-selected', selected);
item.setAttribute('aria-pressed', String(selected));
});
if (stateImageInput) stateImageInput.value = button.dataset.stateImage || '';
if (stateImageTypeInput) stateImageTypeInput.value = button.dataset.stateImageType || '';
if (stateImageHandleInput) stateImageHandleInput.value = button.dataset.stateImageHandle || '';
if (stateOriginalImageInput) stateOriginalImageInput.value = button.dataset.stateImageUrl || '';
const selectedStatePreview = {
title: button.dataset.stateImage || 'Selected state emblem',
imageUrl: button.dataset.stateImageUrl || '',
goldRingRender: button.dataset.stateRenderGold || '',
silverRingRender: button.dataset.stateRenderSilver || '',
phantomRingRender: button.dataset.stateRenderPhantom || '',
athenaGoldRingRender: button.dataset.stateRenderAthenaGold || '',
athenaSilverRingRender: button.dataset.stateRenderAthenaSilver || '',
athenaPhantomRingRender: button.dataset.stateRenderAthenaPhantom || '',
apolloGoldRingRender: button.dataset.stateRenderApolloGold || '',
apolloSilverRingRender: button.dataset.stateRenderApolloSilver || '',
apolloPhantomRingRender: button.dataset.stateRenderApolloPhantom || '',
signetGoldRingRender: button.dataset.stateRenderSignetGold || '',
signetSilverRingRender: button.dataset.stateRenderSignetSilver || '',
signetPhantomRingRender: button.dataset.stateRenderSignetPhantom || ''
};
if (stateRingRenderInput) stateRingRenderInput.value = getRingRenderForTone(selectedStatePreview);
activateEmblemPreview(selectedStatePreview, 'state');
if (typeof updateStyleSpecificProperties === 'function') updateStyleSpecificProperties();
clearError();
};
const closeStateLightbox = () => {
if (!stateLightbox) return;
stateLightbox.classList.remove('is-open');
stateLightbox.setAttribute('aria-hidden', 'true');
document.body.classList.remove('sr-state-lightbox-open');
if (stateLightboxReturnFocus && typeof stateLightboxReturnFocus.focus === 'function') {
stateLightboxReturnFocus.focus({ preventScroll: true });
}
stateLightboxReturnFocus = null;
};
const updateStateLightbox = () => {
if (!stateLightbox || !stateLightboxItems.length) return;
const item = stateLightboxItems[stateLightboxIndex];
const media = stateLightbox.querySelector('[data-state-lightbox-media]');
const title = stateLightbox.querySelector('[data-state-lightbox-title]');
const type = stateLightbox.querySelector('[data-state-lightbox-type]');
const counter = stateLightbox.querySelector('[data-state-lightbox-counter]');
const prev = stateLightbox.querySelector('[data-state-lightbox-prev]');
const next = stateLightbox.querySelector('[data-state-lightbox-next]');
if (media) {
media.innerHTML = item.imageUrl
? `<img src="${escapeHtml(item.imageUrl)}" alt="${escapeHtml(item.altText)}" decoding="async">`
: `<span class="sr-ring-builder__state-lightbox-fallback">${escapeHtml(item.fallbackText)}</span>`;
}
if (title) title.textContent = item.title;
if (type) type.textContent = item.type;
if (counter) counter.textContent = `${stateLightboxIndex + 1} of ${stateLightboxItems.length}`;
const hasMultiple = stateLightboxItems.length > 1;
if (prev) prev.disabled = !hasMultiple;
if (next) next.disabled = !hasMultiple;
};
const ensureStateLightbox = () => {
if (stateLightbox) return stateLightbox;
stateLightbox = document.createElement('div');
stateLightbox.className = 'sr-ring-builder__state-lightbox';
stateLightbox.setAttribute('aria-hidden', 'true');
stateLightbox.setAttribute('role', 'dialog');
stateLightbox.setAttribute('aria-modal', 'true');
stateLightbox.innerHTML = `
<div class="sr-ring-builder__state-lightbox-backdrop" data-state-lightbox-close></div>
<div class="sr-ring-builder__state-lightbox-dialog" role="document">
<button class="sr-ring-builder__state-lightbox-close" type="button" data-state-lightbox-close data-state-lightbox-close-button aria-label="Close expanded image">
<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
</button>
<div class="sr-ring-builder__state-lightbox-media" data-state-lightbox-media></div>
<div class="sr-ring-builder__state-lightbox-copy">
<span data-state-lightbox-counter>1 of 1</span>
<strong data-state-lightbox-title>State image</strong>
<small data-state-lightbox-type>Image</small>
</div>
<div class="sr-ring-builder__state-lightbox-controls">
<button class="sr-ring-builder__state-lightbox-nav" type="button" data-state-lightbox-prev>Previous</button>
<button class="sr-ring-builder__state-lightbox-select" type="button" data-state-lightbox-select>Select image</button>
<button class="sr-ring-builder__state-lightbox-nav" type="button" data-state-lightbox-next>Next</button>
</div>
</div>
`;
root.appendChild(stateLightbox);
stateLightbox.addEventListener('click', (event) => {
if (event.target.closest('[data-state-lightbox-close]')) {
closeStateLightbox();
return;
}
if (event.target.closest('[data-state-lightbox-prev]')) {
if (!stateLightboxItems.length) return;
stateLightboxIndex = (stateLightboxIndex - 1 + stateLightboxItems.length) % stateLightboxItems.length;
updateStateLightbox();
return;
}
if (event.target.closest('[data-state-lightbox-next]')) {
if (!stateLightboxItems.length) return;
stateLightboxIndex = (stateLightboxIndex + 1) % stateLightboxItems.length;
updateStateLightbox();
return;
}
if (event.target.closest('[data-state-lightbox-select]')) {
const activeItem = stateLightboxItems[stateLightboxIndex];
if (activeItem && typeof activeItem.select === 'function') activeItem.select();
closeStateLightbox();
}
});
document.addEventListener('keydown', (event) => {
if (!stateLightbox || !stateLightbox.classList.contains('is-open')) return;
if (event.key === 'Escape') closeStateLightbox();
if (event.key === 'ArrowLeft' && stateLightboxItems.length > 1) {
stateLightboxIndex = (stateLightboxIndex - 1 + stateLightboxItems.length) % stateLightboxItems.length;
updateStateLightbox();
}
if (event.key === 'ArrowRight' && stateLightboxItems.length > 1) {
stateLightboxIndex = (stateLightboxIndex + 1) % stateLightboxItems.length;
updateStateLightbox();
}
});
return stateLightbox;
};
const openStateLightbox = (button) => {
stateLightboxReturnFocus = document.activeElement;
const buttons = getStateEmblemButtons();
stateLightboxItems = buttons.map(getStateEmblemData);
stateLightboxIndex = Math.max(0, buttons.indexOf(button));
ensureStateLightbox();
updateStateLightbox();
stateLightbox.classList.add('is-open');
stateLightbox.setAttribute('aria-hidden', 'false');
document.body.classList.add('sr-state-lightbox-open');
stateLightbox.querySelector('[data-state-lightbox-close-button]')?.focus({ preventScroll: true });
};
const openSportLightbox = (sportOption) => {
if (!sportOption) return;
stateLightboxReturnFocus = document.activeElement;
stateLightboxItems = [{
title: sportOption.label,
type: 'Sport Emblem',
imageUrl: sportOption.imageUrl,
altText: sportOption.altText,
fallbackText: sportOption.baseName.slice(0, 2).toUpperCase(),
button: null,
select: () => selectSportEmblemOption(sportOption.label)
}];
stateLightboxIndex = 0;
ensureStateLightbox();
updateStateLightbox();
stateLightbox.classList.add('is-open');
stateLightbox.setAttribute('aria-hidden', 'false');
document.body.classList.add('sr-state-lightbox-open');
stateLightbox.querySelector('[data-state-lightbox-close-button]')?.focus({ preventScroll: true });
};
const populateSports = () => {
populateSportDropdown();
};
const renderSports = (query = '') => {
if (!sportGrid) return;
const normalizedQuery = String(query || '').trim().toLowerCase();
const visibleSports = getSportOptions().filter((sport) => sport.label.toLowerCase().includes(normalizedQuery) || sport.baseName.toLowerCase().includes(normalizedQuery));
if (sportEmpty) sportEmpty.hidden = visibleSports.length > 0;
sportGrid.innerHTML = visibleSports.map((sport) => `
<button class="sr-ring-builder__sport-button${sportInput && sportInput.value === sport.label ? ' is-selected' : ''}" type="button" data-sport="${escapeHtml(sport.label)}" aria-pressed="${sportInput && sportInput.value === sport.label}">
<span class="sr-ring-builder__sport-icon" aria-hidden="true">${escapeHtml(sport.icon)}</span>
<strong title="${escapeHtml(sport.label)}">${escapeHtml(sport.label)}</strong>
</button>
`).join('');
};

const ensureStateUi = () => {
if (stateUiInitialized) return;
stateUiInitialized = true;
populateStateSelect();
};

const ensureSportUi = () => {
if (sportUiInitialized) return;
sportUiInitialized = true;
populateSports();
renderSports();
updateSelectedSportEmblem();
};
const updateStyleSpecificProperties = () => {
const styleKey = selectedStyleKey();
const sportValue = sportInput ? sportInput.value : '';
const stateImageValue = stateImageInput ? stateImageInput.value : '';
const stateValue = stateInput ? stateInput.value : '';
const combinedState = stateImageValue ? `${stateValue ? `${stateValue} — ` : ''}${stateImageValue}` : '';
const needsSport = styleNeedsSport();
const needsState = styleNeedsState();
if (sportInput) sportInput.disabled = !needsSport;
if (sportEmblemGenderInput) sportEmblemGenderInput.disabled = !needsSport;
if (sportEmblemImageInput) sportEmblemImageInput.disabled = !needsSport;
if (sportEmblemHandleInput) sportEmblemHandleInput.disabled = !needsSport;
if (sportRingRenderInput) sportRingRenderInput.disabled = !needsSport;
if (stateInput) stateInput.disabled = !needsState;
if (stateImageInput) stateImageInput.disabled = !needsState;
if (stateImageTypeInput) stateImageTypeInput.disabled = !needsState;
if (stateImageHandleInput) stateImageHandleInput.disabled = !needsState;
if (stateOriginalImageInput) stateOriginalImageInput.disabled = !needsState;
if (stateRingRenderInput) stateRingRenderInput.disabled = !needsState;
root.querySelectorAll('[data-style-sport-property]').forEach((field) => {
const active = field.dataset.styleSportProperty === styleKey && needsSport;
field.disabled = !active;
field.value = active ? sportValue : '';
});
root.querySelectorAll('[data-style-state-property]').forEach((field) => {
const active = field.dataset.styleStateProperty === styleKey && needsState;
field.disabled = !active;
field.value = active ? combinedState : '';
});
if (reviewSport) reviewSport.textContent = sportValue || 'Not selected';
if (reviewState) reviewState.textContent = combinedState || 'Not selected';
if (reviewSportRow) reviewSportRow.hidden = !needsSport;
if (reviewStateRow) reviewStateRow.hidden = !needsState;
};
const updatePersonalizationGroup = () => {
const style = selectedStyle();
const styleKey = style ? style.dataset.styleKey : '';
root.querySelectorAll('[data-personalization-group]').forEach((group) => {
const active = group.dataset.personalizationGroup === styleKey;
group.hidden = !active;
group.querySelectorAll('input, select, textarea').forEach((field) => {
field.disabled = !active;
});
});
if (!styleNeedsSport()) {
if (sportDropdown) sportDropdown.value = '';
setSelectedSportOption(null, false);
if (sportEmblemPreview) {
sportEmblemPreview.hidden = true;
sportEmblemPreview.innerHTML = '';
}
}
if (!styleNeedsState()) {
if (stateInput) stateInput.value = '';
if (stateSelect) stateSelect.value = '';
resetStateImageSelection(false);
}
updateStyleSpecificProperties();
};
const previewImageCache = new Map();
const preloadPreviewImage = (imageUrl, priority = 'auto') => {
if (!imageUrl) return Promise.resolve(null);
if (previewImageCache.has(imageUrl)) return previewImageCache.get(imageUrl);
const image = new Image();
image.decoding = 'async';
if ('fetchPriority' in image) image.fetchPriority = priority;
const request = new Promise((resolve, reject) => {
image.onload = () => {
if (typeof image.decode === 'function') {
image.decode().catch(() => {}).finally(() => resolve(image));
} else {
resolve(image);
}
};
image.onerror = () => {
previewImageCache.delete(imageUrl);
reject(new Error('Preview image failed to load'));
};
});
image.src = imageUrl;
previewImageCache.set(imageUrl, request);
return request;
};
let previewRequestId = 0;
const responsiveSrcsetFor = (imageUrl) => {
try {
const url = new URL(imageUrl, window.location.origin);
if (!url.searchParams.has('width')) return '';
return [360, 540, 720, 960, 1200].map((width) => {
const candidate = new URL(url.toString());
candidate.searchParams.set('width', String(width));
return `${candidate.toString()} ${width}w`;
}).join(', ');
} catch (error) {
return '';
}
};
const ensurePreviewPlaceholder = () => {
if (imagePlaceholder) return imagePlaceholder;
if (!visualFrame) return null;
imagePlaceholder = document.createElement('div');
imagePlaceholder.className = 'sr-ring-builder__image-placeholder';
imagePlaceholder.dataset.imagePlaceholder = '';
imagePlaceholder.innerHTML = '<span>Assign this exact style and tone image in Theme Editor</span>';
const chipOverlay = visualFrame.querySelector('.sr-ring-builder__visual-chip-overlay');
if (chipOverlay) visualFrame.insertBefore(imagePlaceholder, chipOverlay);
else visualFrame.appendChild(imagePlaceholder);
return imagePlaceholder;
};
const ensurePreviewImage = () => {
if (ringImage) return ringImage;
if (!visualFrame) return null;
ringImage = document.createElement('img');
ringImage.className = 'sr-ring-builder__image';
ringImage.loading = 'eager';
ringImage.fetchPriority = 'high';
ringImage.decoding = 'async';
ringImage.width = 1200;
ringImage.height = 1200;
ringImage.sizes = '(min-width: 990px) 40vw, 100vw';
const placeholder = ensurePreviewPlaceholder();
visualFrame.insertBefore(ringImage, placeholder || visualFrame.firstChild);
return ringImage;
};
const updatePreviewImage = (imageUrl, altText) => {
const requestId = ++previewRequestId;
const normalizedUrl = String(imageUrl || '').trim();
if (!normalizedUrl) {
if (ringImage) {
ringImage.classList.remove('is-changing');
ringImage.hidden = true;
ringImage.removeAttribute('src');
ringImage.removeAttribute('srcset');
ringImage.removeAttribute('alt');
ringImage.style.setProperty('display', 'none', 'important');
ringImage.style.setProperty('visibility', 'hidden', 'important');
ringImage.style.setProperty('opacity', '0', 'important');
}
const placeholder = ensurePreviewPlaceholder();
if (placeholder) {
placeholder.hidden = false;
placeholder.style.setProperty('display', 'grid', 'important');
}
return;
}
const image = ensurePreviewImage();
if (!image) return;
image.hidden = false;
image.style.removeProperty('display');
image.style.removeProperty('visibility');
image.style.removeProperty('opacity');
const placeholder = ensurePreviewPlaceholder();
if (placeholder) {
placeholder.hidden = true;
placeholder.style.setProperty('display', 'none', 'important');
}
const currentSrc = image.getAttribute('src') || '';
if (currentSrc === normalizedUrl || image.src === normalizedUrl) {
image.alt = altText || productLabel;
return;
}
image.classList.add('is-changing');
const preload = new Image();
preload.onload = () => {
if (requestId !== previewRequestId) return;
image.src = normalizedUrl;
const nextSrcset = responsiveSrcsetFor(normalizedUrl);
if (nextSrcset) image.srcset = nextSrcset;
else image.removeAttribute('srcset');
image.alt = altText || productLabel;
requestAnimationFrame(() => image.classList.remove('is-changing'));
};
preload.onerror = () => {
if (requestId !== previewRequestId) return;
image.classList.remove('is-changing');
image.hidden = true;
image.removeAttribute('src');
image.removeAttribute('srcset');
image.removeAttribute('alt');
image.style.setProperty('display', 'none', 'important');
const failedPlaceholder = ensurePreviewPlaceholder();
if (failedPlaceholder) {
failedPlaceholder.hidden = false;
failedPlaceholder.style.setProperty('display', 'grid', 'important');
}
};
preload.src = normalizedUrl;
};
const updateCartPreviewImageProperty = (imageUrl, altText) => {
if (cartPreviewImageInput) cartPreviewImageInput.value = imageUrl || '';
if (cartPreviewAltInput) cartPreviewAltInput.value = altText || `${productLabel} selected preview`;
};
const setFinalPreviewMedia = (image, empty, imageUrl, altText) => {
if (!image || !empty) return;
const hasImage = Boolean(imageUrl);
image.hidden = !hasImage;
empty.hidden = hasImage;
if (!hasImage) {
image.removeAttribute('src');
image.removeAttribute('srcset');
return;
}
if (image.getAttribute('src') !== imageUrl) {
image.src = imageUrl;
image.alt = altText || '';
}
};
const getCorePreviewImage = (styleKey, toneKey) => root.getAttribute(`data-core-${styleKey}-${toneKey}`) || '';
const signetPersonalizationStep = Number(root.querySelector('[data-personalization-group="hermes"]')?.closest('[data-step]')?.dataset.step || -1);
const signetReviewStep = Number(root.querySelector('[data-review-style]')?.closest('[data-step]')?.dataset.step || -1);
const athenaPersonalizationStep = Number(root.querySelector('[data-personalization-group="athena"]')?.closest('[data-step]')?.dataset.step || -1);
const apolloPersonalizationStep = Number(root.querySelector('[data-personalization-group="apollo"]')?.closest('[data-step]')?.dataset.step || -1);
const artStep=Number(root.querySelector('[data-personalization-group="artemis"]')?.closest('[data-step]')?.dataset.step||-1);
const isSignetFinalVisualStep = () => root.dataset.builderType === 'signet'
&& (currentStep === signetPersonalizationStep || currentStep === signetReviewStep);
const isAthenaFinalVisualStep = () => root.dataset.builderType === 'fashion_band'
&& selectedStyleKey() === 'athena'
&& currentStep === athenaPersonalizationStep;
const isApolloFinalVisualStep = () => root.dataset.builderType === 'fashion_band'
&& selectedStyleKey() === 'apollo'
&& currentStep === apolloPersonalizationStep;
const isArtFinal=()=>root.dataset.builderType==='fashion_band'&&selectedStyleKey()==='artemis'&&currentStep===artStep;
const getExactToneSideRender = (option) => {
if (!option) return '';
return getRingRenderForTone(option);
};
const logDedicatedRenderStatus = (option, context = '') => {
if (!option) return;
const styleKey = selectedStyleKey();
if (styleKey !== 'athena' && styleKey !== 'apollo') return;
const toneKey = getSelectedRingToneKey();
const fieldMap = styleKey === 'athena'
? {
gold: option.athenaGoldRingRender,
silver: option.athenaSilverRingRender,
phantom: option.athenaPhantomRingRender
}
: {
gold: option.apolloGoldRingRender,
silver: option.apolloSilverRingRender,
phantom: option.apolloPhantomRingRender
};
if (!fieldMap[toneKey]) {
console.warn(`[SR Ring Builder] Missing ${styleKey} ${toneKey} dedicated metaobject render${context ? ` (${context})` : ''}.`, {
style: styleKey,
tone: toneKey,
option: option.label || option.title || option.handle || '',
dedicatedFields: fieldMap
});
}
};
const setAthenaPreviewMedia = (image, empty, imageUrl, altText) => {
if (!image || !empty) return;
const url = String(imageUrl || '').trim();
image.hidden = !url;
empty.hidden = Boolean(url);
if (!url) {
image.removeAttribute('src');
image.removeAttribute('srcset');
image.removeAttribute('alt');
return;
}
if (image.getAttribute('src') !== url) image.src = url;
image.alt = altText || '';
};
const setApolloPreviewMedia = (media, empty, imageUrl, altText) => {
if (!media || !empty) return;
const url = String(imageUrl || '').trim();
const hasImage = Boolean(url);
media.hidden = !hasImage;
empty.hidden = hasImage;
if (!hasImage) {
media.style.removeProperty('background-image');
media.removeAttribute('aria-label');
media.dataset.renderUrl = '';
return;
}
if (media.dataset.renderUrl !== url) {
const escapedUrl = url.replace(/["\\]/g, '\\$&');
media.style.setProperty('background-image', `url("${escapedUrl}")`, 'important');
media.dataset.renderUrl = url;
}
media.setAttribute('aria-label', altText || 'Apollo ring rendering');
};
const updateAthenaFinalVisual = () => {
if (!athenaFinalVisual || root.dataset.builderType !== 'fashion_band' || selectedStyleKey() !== 'athena') return;
const toneKey = getSelectedRingToneKey();
const sportRingUrl = String(root.getAttribute(`data-athena-sport-side-${toneKey}`) || '').trim();
const stateRingUrl = String(root.getAttribute(`data-athena-state-side-${toneKey}`) || '').trim();
logDedicatedRenderStatus(selectedSportEmblemPreview, 'Athena sport');
logDedicatedRenderStatus(selectedStateEmblemPreview, 'Athena state');
const sportSelectionUrl = getExactToneSideRender(selectedSportEmblemPreview);
const stateSelectionUrl = getExactToneSideRender(selectedStateEmblemPreview);
setAthenaPreviewMedia(
athenaSportRingImage,
athenaSportRingEmpty,
sportRingUrl,
'Athena Side 1 sport ring image from Theme Editor'
);
setAthenaPreviewMedia(
athenaSportSelectionImage,
athenaSportSelectionEmpty,
sportSelectionUrl,
`${selectedSportEmblemPreview?.label || 'Selected sport'} metaobject ring render`
);
setAthenaPreviewMedia(
athenaStateRingImage,
athenaStateRingEmpty,
stateRingUrl,
'Athena Side 2 state ring image from Theme Editor'
);
setAthenaPreviewMedia(
athenaStateSelectionImage,
athenaStateSelectionEmpty,
stateSelectionUrl,
`${selectedStateEmblemPreview?.title || 'Selected state'} metaobject ring render`
);
[sportRingUrl, stateRingUrl, sportSelectionUrl, stateSelectionUrl].filter(Boolean).forEach((url) => {
if (typeof preloadPreviewImage === 'function') preloadPreviewImage(url, 'low').catch(() => {});
});
};
const updateApolloFinalVisual = () => {
if (!apolloFinalVisual || root.dataset.builderType !== 'fashion_band' || selectedStyleKey() !== 'apollo') return;
const toneKey = getSelectedRingToneKey();
const frontUrl = getExactThemePreviewImage('apollo', toneKey);
logDedicatedRenderStatus(selectedSportEmblemPreview, 'Apollo sport');
const backUrl = getExactToneSideRender(selectedSportEmblemPreview);
const tone = selectedTone();
const toneText = tone ? tone.value : 'Selected tone';
setApolloPreviewMedia(
apolloFrontImage,
apolloFrontEmpty,
frontUrl,
`Apollo front rendering — ${toneText}`
);
setApolloPreviewMedia(
apolloBackImage,
apolloBackEmpty,
backUrl,
`${selectedSportEmblemPreview?.label || 'Selected sport'} back rendering`
);
if (apolloFrontLabel) apolloFrontLabel.textContent = `The Apollo · ${toneText}`;
if (apolloBackLabel) apolloBackLabel.textContent = selectedSportEmblemPreview?.label || 'Not selected';
[frontUrl, backUrl].filter(Boolean).forEach((url) => {
if (typeof preloadPreviewImage === 'function') preloadPreviewImage(url, 'low').catch(() => {});
});
};
const updateArt=()=>{if(!finalVisual)return;const t=getSelectedRingToneKey(),k=t[0],tone=selectedTone(),f=getExactThemePreviewImage('artemis',t),a=x=>String(root.getAttribute(x)||'').trim(),s1=a(`data-art-s1-${k}`),s2=a(`data-art-s2-${k}`),c=getCorePreviewImage('artemis',t),i=form.querySelector('input[name="properties[Artemis Core Engraving]"]'),v=String(i?i.value:'').trim();if(coreRingRenderInput)coreRingRenderInput.value=c||'';if(finalCoreText)finalCoreText.dataset.tone=t;setFinalPreviewMedia(finalBezelImage,finalBezelEmpty,f,`Artemis ${tone?tone.value:''}`);setFinalPreviewMedia(finalSportImage,finalSportEmpty,s1,'Artemis Side 1');setFinalPreviewMedia(finalStateImage,finalStateEmpty,s2,'Artemis Side 2');setFinalPreviewMedia(finalCoreImage,finalCoreEmpty,c,'Artemis Core');if(finalSportLabel)finalSportLabel.textContent='Side 1';if(finalStateLabel)finalStateLabel.textContent='Side 2';if(finalCoreLabel)finalCoreLabel.textContent=v||'Core';if(finalCoreText){finalCoreText.textContent=v;finalCoreText.hidden=!(c&&v)}};
const updateFinalVisual = () => {
if(root.dataset.builderType==='fashion_band'){if(selectedStyleKey()==='athena'){updateAthenaFinalVisual();return}if(selectedStyleKey()==='apollo'){updateApolloFinalVisual();return}if(selectedStyleKey()==='artemis'){updateArt();return}return}
if (!finalVisual || root.dataset.builderType !== 'signet') return;
const style = selectedStyle();
const tone = selectedTone();
const styleKey = selectedStyleKey() || 'hermes';
const styleText = style ? style.value : 'The Hermes';
const toneText = tone ? tone.value : 'Gold';
const toneKey = getSelectedRingToneKey();
const bezelUrl = getExactThemePreviewImage(styleKey, toneKey);
const sportUrl = getRingRenderForTone(selectedSportEmblemPreview);
const stateUrl = getRingRenderForTone(selectedStateEmblemPreview);
const coreUrl = getCorePreviewImage(styleKey, toneKey);
const coreInput = form.querySelector('input[name="properties[Hermes Core Custom Text]"]');
const coreValue = String(coreInput ? coreInput.value : '').trim();
if (coreRingRenderInput) coreRingRenderInput.value = coreUrl || '';
if (finalCoreText) finalCoreText.dataset.tone = toneKey;
setFinalPreviewMedia(finalBezelImage, finalBezelEmpty, bezelUrl, `${styleText} ${toneText} bezel preview`);
setFinalPreviewMedia(finalSportImage, finalSportEmpty, sportUrl, `${selectedSportEmblemPreview?.label || 'Selected sport'} side render`);
setFinalPreviewMedia(finalStateImage, finalStateEmpty, stateUrl, `${selectedStateEmblemPreview?.title || 'Selected state'} side render`);
setFinalPreviewMedia(finalCoreImage, finalCoreEmpty, coreUrl, `${styleText} ${toneText} core engraving preview`);
if (finalBezelLabel) finalBezelLabel.textContent = `${styleText} · ${toneText}`;
if (finalSportLabel) finalSportLabel.textContent = selectedSportEmblemPreview?.label || (sportInput ? sportInput.value : '') || 'Not selected';
if (finalStateLabel) finalStateLabel.textContent = selectedStateEmblemPreview?.title || (stateImageInput ? stateImageInput.value : '') || 'Not selected';
if (finalCoreLabel) finalCoreLabel.textContent = coreValue || 'Custom text';
if (finalCoreText) {
finalCoreText.textContent = coreValue;
finalCoreText.hidden = !(coreUrl && coreValue);
}
[bezelUrl, sportUrl, stateUrl, coreUrl].filter(Boolean).forEach((url) => {
if (typeof preloadPreviewImage === 'function') preloadPreviewImage(url, 'low').catch(() => {});
});
};
const athenaSportSelectStep=Number(root.querySelector('[data-conditional-step="sport"]')?.dataset.step||-1);
const athenaStateSelectStep=Number(root.querySelector('[data-conditional-step="state-image"]')?.dataset.step||-1);
const isAthenaSelectVisualStep=()=>root.dataset.builderType==='fashion_band'&&selectedStyleKey()==='athena'&&(currentStep===athenaSportSelectStep||currentStep===athenaStateSelectStep);
const athenaSelectOption=()=>currentStep===athenaSportSelectStep?selectedSportEmblemPreview:selectedStateEmblemPreview;
const athenaSelectReady=()=>isAthenaSelectVisualStep()&&!!getExactToneSideRender(athenaSelectOption());
const updateAthenaSelectVisual=()=>{
if(!athenaSelectVisual||!athenaSelectReady())return;
const sport=currentStep===athenaSportSelectStep,option=athenaSelectOption(),toneKey=getSelectedRingToneKey();
const renderedUrl=String(getExactToneSideRender(option)||'').trim();
const sideUrl=String(root.getAttribute(`data-athena-${sport?'sport':'state'}-side-${toneKey}`)||'').trim();
athenaSelectEmblem.hidden=!renderedUrl;
if(renderedUrl){athenaSelectEmblem.src=renderedUrl;athenaSelectEmblem.alt=option?.label||option?.title||'Selected render';}
else athenaSelectEmblem.removeAttribute('src');
athenaSelectRing.hidden=!sideUrl;athenaSelectRingEmpty.hidden=!!sideUrl;
if(sideUrl){athenaSelectRing.src=sideUrl;athenaSelectRing.alt=`Athena ${sport?'sport':'state'} side`;}
else athenaSelectRing.removeAttribute('src');
};
const syncFinalVisualMode = () => {
const signetActive=isSignetFinalVisualStep(),athenaActive=isAthenaFinalVisualStep(),apolloActive=isApolloFinalVisualStep(),artActive=isArtFinal(),athenaSelectActive=athenaSelectReady(),active=signetActive||athenaActive||apolloActive||artActive||athenaSelectActive;root.classList.toggle('is-final-visual',active);if(finalVisual)finalVisual.hidden=!(signetActive||artActive);if(athenaFinalVisual)athenaFinalVisual.hidden=!athenaActive;if(apolloFinalVisual)apolloFinalVisual.hidden=!apolloActive;if(athenaSelectVisual){athenaSelectVisual.hidden=!athenaSelectActive;athenaSelectVisual.classList.toggle('is-visible',athenaSelectActive);}
if (imagePlaceholder) imagePlaceholder.hidden = active;
if (signetActive) {
updateFinalVisual();
if (ringCaption) ringCaption.textContent = 'complete signet configuration — bezel, Side 1, Side 2 and core';
} else if (athenaActive) {
updateAthenaFinalVisual();
}else if(apolloActive){updateApolloFinalVisual()}else if(artActive){updateArt()}else if(athenaSelectActive){updateAthenaSelectVisual()}};
const updateSummary = () => {
if (summaryUpdateInProgress) return;
summaryUpdateInProgress = true;
try {
const style = selectedStyle();
const tone = selectedTone();
const styleKey = selectedStyleKey();
const styleText = style ? style.value : '';
const toneText = tone ? tone.value : '';
const sizeText = style ? (style.dataset.styleSize || '') : '';
const toneKey = tone ? String(tone.dataset.toneKey || '').toLowerCase() : '';
const toneImage = getExactThemePreviewImage(styleKey, toneKey);
if (sizePropertyInput) sizePropertyInput.value = sizeText;
if (sizeLabel) sizeLabel.textContent = sizeText;
if (reviewStyle) reviewStyle.textContent = styleText;
if (reviewTone) reviewTone.textContent = toneText;
if (reviewSize) reviewSize.textContent = sizeText;
if (previewStyle) previewStyle.textContent = styleText;
if (previewTone) previewTone.textContent = toneText;
if (ringCaption) ringCaption.textContent = `${productLabel.toLowerCase()} — ${styleText.toLowerCase()} — ${toneText.toLowerCase()}`;
updatePersonalizationGroup();
const basePreviewImage = toneImage || '';
const basePreviewAlt = `${styleText || productLabel} ${toneText || ''} ${productLabel}`.replace(/\s+/g, ' ').trim();
const emblemPreview = getActiveEmblemRenderData();
const selectedPreviewImage = emblemPreview.imageUrl || basePreviewImage;
const selectedPreviewAlt = emblemPreview.altText || basePreviewAlt;
updateCartPreviewImageProperty(selectedPreviewImage, selectedPreviewAlt);
updatePreviewImage(selectedPreviewImage,selectedPreviewAlt);updateFinalVisual();updateAthenaSelectVisual();syncFinalVisualMode();
} finally {
summaryUpdateInProgress = false;
}
};
const updateSelectedVariant = () => {
const variant = findSelectedVariant();
const hasSelections = Boolean(selectedStyle() && selectedTone());
if (variant) {
if (variantIdInput) variantIdInput.value = variant.id;
const priceText = formatMoney(variant.price);
if (livePrice) livePrice.textContent = priceText;
if (finalPrice) finalPrice.textContent = priceText;
if (submitButton) submitButton.disabled = variant.available === false;
if (submitLabel) submitLabel.textContent = variant.available === false ? 'Sold out' : 'Add to cart';
return variant;
}
if (submitButton) submitButton.disabled = true;
if (submitLabel) submitLabel.textContent = hasSelections ? 'Variant not found' : 'Choose style & tone';
return null;
};
const updateTimeline = () => {
const activeNumbers = activeStepNumbers();
const currentPosition = activeNumbers.indexOf(currentStep);
timelineNodes.forEach((node) => {
const target = Number(node.dataset.stepJump);
const condition = node.dataset.conditionalNode || '';
const visible = conditionalMatches(condition) && activeNumbers.includes(target);
const listItem = node.closest('li');
node.hidden = !visible;
if (listItem) listItem.hidden = !visible;
if (!visible) {
node.classList.remove('is-active', 'is-complete');
node.removeAttribute('aria-current');
return;
}
const visiblePosition = activeNumbers.indexOf(target);
const dot = node.querySelector('.sr-ring-builder__timeline-dot');
if (dot) dot.textContent = String(visiblePosition + 1);
const isActive = visiblePosition === currentPosition;
const isComplete = visiblePosition > -1 && visiblePosition < currentPosition;
node.classList.toggle('is-active', isActive);
node.classList.toggle('is-complete', isComplete);
if (isActive) node.setAttribute('aria-current', 'step');
else node.removeAttribute('aria-current');
});
};
const showStep = (stepNumber, direction = 1) => {
currentStep = normalizeStep(Math.max(1, Math.min(totalSteps, stepNumber)), direction);
root.dataset.currentStep = String(currentStep);
steps.forEach((step) => {
const stepNumberValue = Number(step.dataset.step);
const active = stepNumberValue === currentStep && shouldUseStep(stepNumberValue);
step.hidden = !active;
step.classList.toggle('is-active', active);
});
syncFinalVisualMode();
const sportStepNumber = Number(root.querySelector('[data-conditional-step="sport"]')?.dataset.step || -1);
const stateStepNumber = Number(root.querySelector('[data-conditional-step="state"]')?.dataset.step || -1);
const stateImageStepNumber = Number(root.querySelector('[data-conditional-step="state-image"]')?.dataset.step || -1);
if (currentStep === sportStepNumber) ensureSportUi();
if (currentStep === stateStepNumber || currentStep === stateImageStepNumber) ensureStateUi();
if (currentStep === stateImageStepNumber) renderStateEmblems();
if (typeof updateSummary === 'function') updateSummary();
const activeNumbers = activeStepNumbers();
const currentPosition = Math.max(1, activeNumbers.indexOf(currentStep) + 1);
const visibleTotal = activeNumbers.length || totalSteps;
const percent = Math.round((currentPosition / visibleTotal) * 100);
if (progressBar) if (progressBar) progressBar.style.transform = `scaleX(${percent / 100})`;
if (progressLabel) progressLabel.textContent = `Step ${currentPosition} of ${visibleTotal}`;
if (progressPercent) progressPercent.textContent = `${percent}%`;
if (backButton) {
const routedProduct = root.dataset.builderType !== 'championship';
backButton.hidden = currentPosition === 1 && !routedProduct;
const backText = backButton.querySelector('[data-back-text]');
if (backText) backText.textContent = routedProduct && currentPosition === 1 ? 'Back to styles' : 'Back';
}
if (nextButton) nextButton.hidden = currentPosition === visibleTotal;
updateTimeline();
clearError();
scrollBuilderToTop();
};
const validateStep = (stepNumber) => {
clearError();
if (!shouldUseStep(stepNumber)) return true;
const step = steps.find((item) => Number(item.dataset.step) === Number(stepNumber));
if (!step) return true;
const requiredFields = Array.from(step.querySelectorAll('[data-required], [data-required-personalization], [data-required-sport], [data-required-state], [data-required-state-image]'))
.filter((field) => !field.disabled && !field.closest('[hidden]'));
for (const field of requiredFields) {
if (field.type === 'radio') {
const group = Array.from(step.querySelectorAll('input[type="radio"]')).filter((radio) => radio.name === field.name);
if (!group.some((radio) => radio.checked)) {
showError('Please make a selection before continuing.', field);
return false;
}
continue;
}
if (!String(field.value || '').trim()) {
showError('Please complete the required field before continuing.', field);
return false;
}
}
return true;
};
if (sportGrid) {
sportGrid.addEventListener('click', (event) => {
const button = event.target.closest('[data-sport]');
if (!button) return;
if (sportDropdown) sportDropdown.value = button.dataset.sport;
setSelectedSportOption(null);
updateSelectedSportEmblem();
renderSports(sportSearch ? sportSearch.value : '');
updateStyleSpecificProperties();
clearError();
});
}
if (sportSearch) sportSearch.addEventListener('input', () => renderSports(sportSearch.value));
if (sportEmblemPreview) {
sportEmblemPreview.addEventListener('click', (event) => {
const card = event.target.closest('[data-sport-emblem-card]');
if (!card) return;
const selectedOption = emblemsForSport(sportDropdown ? sportDropdown.value : '').find((item) => item.label === card.dataset.sportLabel) || findSportOptionByLabel(card.dataset.sportLabel || '');
if (event.target.closest('[data-sport-emblem-expand]')) {
event.preventDefault();
event.stopPropagation();
openSportLightbox(selectedOption);
return;
}
selectSportEmblemOption(card.dataset.sportLabel || '');
});
sportEmblemPreview.addEventListener('keydown', (event) => {
if (event.key !== 'Enter' && event.key !== ' ') return;
const card = event.target.closest('[data-sport-emblem-card]');
if (!card) return;
event.preventDefault();
if (event.target.closest('[data-sport-emblem-expand]')) {
const selectedOption = emblemsForSport(sportDropdown ? sportDropdown.value : '').find((item) => item.label === card.dataset.sportLabel) || findSportOptionByLabel(card.dataset.sportLabel || '');
openSportLightbox(selectedOption);
return;
}
selectSportEmblemOption(card.dataset.sportLabel || '');
});
}
form.addEventListener('change', (event) => {
clearError();
if (event.target.matches('[data-style-choice], [data-tone-choice]')) {
updateSummary();
updateSelectedVariant();
updateTimeline();
if (!shouldUseStep(currentStep)) showStep(normalizeStep(currentStep, 1), 1);
}
if (event.target === sportDropdown) {
setSelectedSportOption(null);
updateSelectedSportEmblem();
renderSports(sportSearch ? sportSearch.value : '');
updateStyleSpecificProperties();
}
if (event.target === stateSelect) {
if (stateInput) stateInput.value = stateSelect.value;
renderStateEmblems();
updateStyleSpecificProperties();
}
});
form.querySelectorAll('input[maxlength]').forEach((input) => {
const count = input.parentElement.querySelector('[data-count]');
if (!count) return;
input.addEventListener('input', () => {
count.textContent = input.value.length;
clearError();
if (typeof updateFinalVisual === 'function') updateFinalVisual();
});
});
if (nextButton) {
nextButton.addEventListener('click', () => {
if (validateStep(currentStep)) showStep(nextStepNumber(currentStep), 1);
});
}
if (backButton) {
backButton.addEventListener('click', () => {
const active = activeStepNumbers();
const currentPosition = Math.max(1, active.indexOf(currentStep) + 1);
if (currentPosition <= 1 && root.dataset.builderType !== 'championship') {
const gatewayUrl = getGatewayUrl();
if (gatewayUrl) {
window.location.assign(gatewayUrl);
} else {
showError('Main style selector URL is missing. Open the main Championship builder first, or set the Main style selector URL in this section setting.');
}
return;
}
showStep(previousStepNumber(currentStep), -1);
});
}
timelineNodes.forEach((node) => {
node.addEventListener('click', () => {
const target = Number(node.dataset.stepJump);
if (target === currentStep) return;
if (target < currentStep) {
showStep(target);
return;
}
const active = activeStepNumbers().filter((stepNumber) => stepNumber >= currentStep && stepNumber < target);
for (const step of active) {
if (!validateStep(step)) {
showStep(step, 1);
validateStep(step);
return;
}
}
showStep(target, 1);
});
});
if (stateEmblems) {
stateEmblems.addEventListener('click', (event) => {
const expandControl = event.target.closest('[data-emblem-expand]');
if (expandControl) {
event.preventDefault();
event.stopPropagation();
const expandButton = expandControl.closest('[data-state-image]');
if (expandButton) openStateLightbox(expandButton);
return;
}
const button = event.target.closest('[data-state-image]');
if (!button) return;
selectStateEmblemButton(button);
});
stateEmblems.addEventListener('keydown', (event) => {
const expandControl = event.target.closest('[data-emblem-expand]');
if (!expandControl || (event.key !== 'Enter' && event.key !== ' ')) return;
event.preventDefault();
event.stopPropagation();
const expandButton = expandControl.closest('[data-state-image]');
if (expandButton) openStateLightbox(expandButton);
});
}
form.addEventListener('submit', (event) => {
for (const step of activeStepNumbers()) {
if (!validateStep(step)) {
event.preventDefault();
showStep(step, 1);
validateStep(step);
return;
}
}
updateSummary();
const variant = updateSelectedVariant();
if (!variant) {
event.preventDefault();
showStep(root.dataset.builderType === 'signet' ? 1 : 2);
showError('Shopify does not have one unambiguous variant for this style and tone. Check the product variant option names and values.');
return;
}
if (variantIdInput) variantIdInput.value = variant.id;
if (submitButton) submitButton.disabled = true;
if (submitLabel) submitLabel.textContent = `Adding your ${productLabel.toLowerCase()}…`;
});
applyRoutedStyleSelection();
updateSummary();
updateSelectedVariant();
showStep(hasCollectiveStyleRoute ? 2 : 1, 1);
allowStepScroll = true;

  };

  const boot = (scope = document) => {
    if (scope.matches && scope.matches('[data-sr-universal-ring-builder]')) initBuilder(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-sr-universal-ring-builder]').forEach(initBuilder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });
})();
